__turbopack_context__.v({
  "aspect-ratio-content": "table-module-scss-module__lNwLWG__aspect-ratio-content",
  "cell": "table-module-scss-module__lNwLWG__cell",
  "cell-inside": "table-module-scss-module__lNwLWG__cell-inside",
  "cell-inside-data": "table-module-scss-module__lNwLWG__cell-inside-data",
  "cell-inside__default": "table-module-scss-module__lNwLWG__cell-inside__default",
  "cell-inside__flat": "table-module-scss-module__lNwLWG__cell-inside__flat",
  "cell-inside__mobile": "table-module-scss-module__lNwLWG__cell-inside__mobile",
  "cell__default": "table-module-scss-module__lNwLWG__cell__default",
  "cell__flat": "table-module-scss-module__lNwLWG__cell__flat",
  "cell__mobile": "table-module-scss-module__lNwLWG__cell__mobile",
  "container": "table-module-scss-module__lNwLWG__container",
  "container-flat": "table-module-scss-module__lNwLWG__container-flat",
  "disabled": "table-module-scss-module__lNwLWG__disabled",
  "end": "table-module-scss-module__lNwLWG__end",
  "holiday": "table-module-scss-module__lNwLWG__holiday",
  "in-range": "table-module-scss-module__lNwLWG__in-range",
  "middle": "table-module-scss-module__lNwLWG__middle",
  "month-name": "table-module-scss-module__lNwLWG__month-name",
  "month-name-native": "table-module-scss-module__lNwLWG__month-name-native",
  "month-name__default": "table-module-scss-module__lNwLWG__month-name__default",
  "multi-selected": "table-module-scss-module__lNwLWG__multi-selected",
  "rack": "table-module-scss-module__lNwLWG__rack",
  "row": "table-module-scss-module__lNwLWG__row",
  "rtl": "table-module-scss-module__lNwLWG__rtl",
  "selected": "table-module-scss-module__lNwLWG__selected",
  "special-best": "table-module-scss-module__lNwLWG__special-best",
  "special-worst": "table-module-scss-module__lNwLWG__special-worst",
  "start": "table-module-scss-module__lNwLWG__start",
  "today": "table-module-scss-module__lNwLWG__today",
  "week-name": "table-module-scss-module__lNwLWG__week-name",
  "week-names-container-desktop": "table-module-scss-module__lNwLWG__week-names-container-desktop",
  "week-names-container-desktop-flat": "table-module-scss-module__lNwLWG__week-names-container-desktop-flat",
  "week-names-container-desktop__default": "table-module-scss-module__lNwLWG__week-names-container-desktop__default",
  "weekend": "table-module-scss-module__lNwLWG__weekend",
});
